export default {
  footerTagline: 'Welcome to Hotel Alpenhof Gauting.',
  footerAddress: 'Unterbrunner Straße 9\n82131 Gauting, Germany',
  footerPhone: '+49 89 8564 2910',
  footerCopyright: '© Hotel Alpenhof Gauting. All rights reserved.',
  footerHomeLink: 'Back to home',
  footerCareerLink: 'Careers at the Alpenhof',
  footerSectionContact: 'Contact',
  footerSectionReception: 'Reception',
  footerReceptionWeekday: 'Mon – Fri · 7 am – 12 noon & 3 – 10 pm',
  footerReceptionWeekend: 'Sat, Sun & holidays · 8 am – 12 noon & 3 – 10 pm',
  footerCtaButton: 'Check availability',
  footerLegalImpressum: 'Imprint',
  footerLegalDatenschutz: 'Privacy',
  footerLegalAgb: 'Terms',

  // Sticky booking banner
  stickyTitle: 'Your stay at the Alpenhof',
  stickyTitleMobile: 'Check availability',
  stickySubtitle: 'Check availability & secure the best rate',
  stickyButton: 'Book now',
};
